import styled, { css } from "styled-components";

export const StyledFeatureCardContainer = styled.div`
  /* background: var(--backgroundModalTransparent); */
  /* backdrop-filter: var(--backdropFilter); */
  /* background: rgba(255, 255, 255, 0.5); */
  padding: 4px 8px 4px;
  border-radius: 4px;
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};
  /* margin: 1px; */
  background: ${({ selected }) =>
    selected ? "rgba(0, 145, 234, 0.28)" : "rgba(255, 255, 255, 0.5)"};

  /* box-shadow: ${({ selected }) =>
    selected ? "0 0 0 1px var(--borderColor)" : "none"}; */
  text-align: ${({ dir }) => (dir === "rtl" ? "right" : "left")};
  :not(:last-child) {
    /* border-bottom: 1px solid #eee; */
  }
`;

export const StyledFeatureCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const StyledFeatureTitle = styled.span`
  font-size: 12px;
  line-height: normal;
`;

export const StyledFeatureImageContainer = styled.div`
  width: 22px;
  height: 22px;
  min-width: 16px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const StyledFeatureCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 2px;
`;

export const StyledFeatureCardBodyTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const StyledFeatureCardBodyText = styled.span`
  font-size: 10px;
  width: 100%;
  ${({ selected }) =>
    selected
      ? css`
          display: block;
          -webkit-line-clamp: unset;
          -webkit-box-orient: unset;
          overflow: visible;
          text-overflow: unset;
        `
      : css`
          display: -webkit-box;
          -webkit-line-clamp: 25; /* or your desired number of lines */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
`;

export const StyledFeatureCardStatus = styled.div``;

export const StyledFeatureCardFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;

  margin-top: 8px;
  /* padding-top: 4px; */
`;

export const StyledFeatureContainer = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: left;
  align-items: center;
  gap: 4px;
  flex: 1;
`;

export const StyledTranslatedText = styled.span`
  font-size: 10px;
  width: 100%;

  a {
    color: var(--fontColor);
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 4px;

  span {
    font-size: 10px;
    color: var(--fontColor);
  }
`;

export const StyledTranslationToggle = styled.span`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const StyledDot = styled.span`
  display: inline-block;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: #7d7d7d;
  margin: ${({ margin }) => margin || "0 6px"};
  vertical-align: middle;
`;

export const StyledEditButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  font: inherit;
`;
